// Misma regla que backend/core/phone.py. Devuelve el motivo o null si es válido/vacío.
export const phoneProblem = (raw, lang = 'es') => {
  const s = (raw || '').trim();
  if (!s) return null;
  const es = lang === 'es';
  if (/[^\d\s\-.()+]/.test(s)) return es ? 'El teléfono solo puede contener números, espacios, guiones y el prefijo +' : 'Phone may only contain digits, spaces, dashes and +';
  const intl = s.startsWith('+') || s.startsWith('00');
  let digits = s.replace(/\D/g, '');
  if (intl) {
    if (s.startsWith('00')) digits = digits.slice(2);
    if (digits.startsWith('34')) {
      const nat = digits.slice(2);
      if (nat.length !== 9 || !'6789'.includes(nat[0])) return es ? 'Teléfono español no válido: tras +34 deben ir 9 dígitos empezando por 6, 7, 8 o 9' : 'Invalid Spanish phone after +34 (9 digits starting 6-9)';
    } else if (digits.length < 8 || digits.length > 15) {
      return es ? 'Teléfono internacional no válido: debe tener entre 8 y 15 dígitos tras el prefijo' : 'Invalid international phone (8-15 digits)';
    }
    return null;
  }
  if (digits.length !== 9 || !'6789'.includes(digits[0])) return es ? 'Teléfono no válido: debe tener 9 dígitos y empezar por 6, 7, 8 o 9 (o usar prefijo internacional +)' : 'Invalid phone: 9 digits starting 6-9 (or use + prefix)';
  return null;
};
